/**
 * @desc 删除
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.systemOrderContract.remove.Params, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderContract/remove`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
